import type { CellStyle } from '../domain/report-style.types';

export interface CorporateTheme {
  readonly defaultAuthor: string;
  readonly defaultColumnWidth: number;
  readonly headerHeight?: number;
  readonly header: Partial<CellStyle>;
  readonly zebraStripe?: Partial<CellStyle>;
  readonly totals?: Partial<CellStyle>;
}

// Vanilla theme: NO visual styling by default. Cells render with
// Excel's native defaults (no bold header, no fill, no borders, no
// custom row heights). Reports that want corporate branding declare
// it explicitly via SheetConfig.headerStyleOverride and per-column
// `cellStyle`. Rationale: we cannot change the look of legacy
// reports without product sign-off, so the framework defaults to
// "look exactly like what the user already had".
export const DEFAULT_CORPORATE_THEME: CorporateTheme = {
  defaultAuthor: 'DFSM',
  defaultColumnWidth: 18,
  header: {},
};
